import EditableText from './EditableText.component';

export default EditableText;
